export type AppRefreshDetail = {
  reason?: string;
};

const EVENT_NAME = "app:data-refresh";

export const fireDataRefresh = (detail?: AppRefreshDetail): void => {
  try {
    window.dispatchEvent(
      new CustomEvent<AppRefreshDetail>(EVENT_NAME, { detail })
    );
  } catch {
    // no-op in non-browser envs
  }
};

export const addDataRefreshListener = (
  handler: (event: CustomEvent<AppRefreshDetail>) => void
): (() => void) => {
  const wrapped = (e: Event) => handler(e as CustomEvent<AppRefreshDetail>);
  window.addEventListener(EVENT_NAME, wrapped as EventListener);
  return () => window.removeEventListener(EVENT_NAME, wrapped as EventListener);
};
